import http from "@/libs/axios";

function ObjectToQueryString(object) {
  let query = "";
  if (!object) {
    return query;
  }
  Object.keys(object).forEach((key) => {
    if (object[key]) {
      query += `&${key}=${object[key]}`;
    }
  });

  if (query.length) {
    query = `?${query.slice(1)}`;
  }

  return query;
}

export function getClientStatus() {
  return http({
    url: "/clients/client-status/",
    method: "GET",
  });
}

export function addNewClient(data) {
  return http({
    url: "/clients/client/",
    method: "POST",
    data,
  });
}

export function updateOneClient(data) {
  return http({
    url: `/clients/client/${data.id}/`,
    method: "PATCH",
    data,
  });
}

export function getClientsList(params) {
  return http({
    url: "/clients/client/",
    method: "GET",
    params,
  });
}

export function getOneClient(id) {
  return http({
    url: `clients/client/${id}/`,
    method: "GET",
  });
}

export function addNewEmploee(data) {
  return http({
    url: "clients/employee",
    method: "POST",
    data,
  });
}

export function updateOneEmployee(data) {
  return http({
    url: `clients/employee/${data.id}`,
    method: "PATCH",
    data,
  });
}

export function getContractList(query) {
  return http({
    url: `sales/orders/${ObjectToQueryString(query)}`,
    method: "GET",
  });
}

export function getComments(query) {
  return http({
    url: `files/comments/${ObjectToQueryString(query)}`,
    method: "GET",
  });
}

export function createComments(data) {
  return http({
    url: "files/comments/",
    method: "POST",
    data,
  });
}

export function deleteComment(id) {
  return http({
    url: `files/comments/${id}/`,
    method: "DELETE",
  });
}

export function updateOneRequisite(data) {
  return http({
    url: `/clients/client-requisite/${data.id}/`,
    method: "PATCH",
    data: data.data,
  });
}

export function deleteOneRequisite(id) {
  return http({
    url: `/clients/client-requisite/${id}/`,
    method: "DELETE",
  });
}

export function addNewRequisite(data) {
  return http({
    url: "/clients/client-requisite/",
    method: "POST",
    data,
  });
}

export function getActivitySpheres() {
  return http({
    url: "/clients/activity-spheres/",
    method: "GET",
  });
}

export function getTargets() {
  return http({
    url: "/clients/targets/",
    method: "GET",
  });
}

export function getAttachmentFiles(query) {
  return http({
    url: `/files/attachments/${ObjectToQueryString(query)}`, // /files/attachments/
    method: "GET",
  });
}

export function addAttachmentFiles(data) {
  return http({
    url: "/files/attachments/",
    method: "POST",
    data,
  });
}

export function deleteAttachmentFiles(id) {
  return http({
    url: `/files/attachments/${id}/`,
    method: "DELETE",
  });
}

export function getClientGroups() {
  return http({
    method: "GET",
    url: "clients/client-groups",
  });
}

export function getClientPaymentTypes() {
  return http({
    method: "GET",
    url: "clients/payment-type",
  });
}

export function getClientInterested() {
  return http({
    method: "GET",
    url: "clients/client-interested/",
  });
}

export function getClientRequests() {
  return http({
    method: "GET",
    url: "clients/client-request/",
  });
}

export function getOneEmployee(id) {
  return http({
    method: "GET",
    url: `/clients/employee/${id}/`,
  });
}

export function getPaymentInstallmentsOfContract(id) {
  return http({
    url: `/clients/client/${id}/contract/`,
    method: "GET",
  });
}
export function getEmployee(params) {
  return http({
    method: "GET",
    url: `/clients/employee/`,
    params,
  });
}
